import { t } from "@lingui/macro";
import { useState, useEffect } from "react";

import { dateUtils } from "@whoosh/utilities";
import { restrictionUtils } from "@whoosh/utilities";
import { getUnlocksInValues } from "@whoosh/utilities/src/dates";

import { getLiftAtForServerTimeOffset } from "../utils/serverTimeOffset";

interface UseRestrictionBlockDataParams {
  startAt?: string | null;
  endAt?: string | null;
  displayStartAt?: string | null;
  liftAt?: string | null;
  allDay?: boolean;
  serverTimeOffsetMs?: number | null;
}

export const useRestrictionBlockData = ({
  startAt,
  endAt,
  displayStartAt,
  liftAt,
  allDay,
  serverTimeOffsetMs,
}: UseRestrictionBlockDataParams) => {
  const { startAt: restrictionStartAt, endAt: restrictionEndAt } =
    restrictionUtils.getTimeOperatorAndStartEndAt(
      displayStartAt ? displayStartAt : startAt,
      endAt
    );

  const formatStartTime = restrictionStartAt
    ? dateUtils.formatHHMM(restrictionStartAt)
    : "";
  const formatEndTime = restrictionEndAt
    ? dateUtils.formatHHMM(restrictionEndAt)
    : "";

  const [showRotatingBorder, setShowRotatingBorder] = useState<boolean>(false);
  const [hideCard, setHideCard] = useState<boolean>(false);

  useEffect(() => {
    setShowRotatingBorder(false);
    setHideCard(false);

    if (liftAt) {
      const interval = setInterval(() => {
        const adjustedLiftAt = getLiftAtForServerTimeOffset(
          liftAt,
          serverTimeOffsetMs
        );
        const { daysLeft, hoursLeft, minutesLeft, secondsLeft } =
          getUnlocksInValues(adjustedLiftAt);

        const tenOrLessSecondsLeft =
          daysLeft === 0 &&
          hoursLeft === 0 &&
          minutesLeft === 0 &&
          secondsLeft < 10;

        const countdownCompleted =
          daysLeft === 0 &&
          hoursLeft === 0 &&
          minutesLeft === 0 &&
          secondsLeft === 0;

        if (tenOrLessSecondsLeft) {
          setShowRotatingBorder(true);
        } else {
          setShowRotatingBorder(false);
        }

        if (countdownCompleted) {
          setHideCard(true);
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [liftAt, serverTimeOffsetMs]);

  const subtitle = allDay
    ? t`All Day`
    : displayStartAt || restrictionEndAt
    ? `${formatStartTime ? formatStartTime : t`Start`} - ${formatEndTime}`
    : "";

  return { subtitle, showRotatingBorder, hideCard };
};
